import { loading, replaceState } from "@/utils/common";
import { OtpResponse } from "@/entities/otpResponse";
import { get } from "@/utils/httpRequest";
import { defineComponent } from "vue";
import { otpStore } from "@/store";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "InitView",
    props: {
        scaSessionId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            redirectUrl: <string | null>"",
            store: otpStore(),
        };
    },
    created() {
        replaceState();
        this.redirectUrl = useRouter().currentRoute.value.query.merchantUrl as string;
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            loading();
            try {
                const response = <OtpResponse>await get(`api/verifyotp/init/${this.scaSessionId}?merchantUrl=${this.redirectUrl}`);
                if (response.data) {
                    this.store.otp = response.data;
                }

                //redirect to error (or restart) view
                if (!response.isSuccess) {
                    this.$router.replace(`/${response.view}/${this.scaSessionId}`);
                }

                //redirect back to merchant
                if (response.data && response.data.redirectUrl && response.returnToMerchant) {
                    window.location.replace(response.data.redirectUrl);
                }

                //redirect to next step
                if (response.view) {
                    this.$router.replace(`/${response.view}/${this.scaSessionId}`);
                }
            } catch (e) {
                console.log("Error while loading page data.", e);
            } finally {
                loading();
            }
        },
    },
});
